import Button from "components/_button/form/submit";
import { renovationConstant } from "constants/form/questions/renovations";
import MainFormContext from "context/main-form";
import { useUpdateProject } from "hooks/useRequest/project";
import dynamic from "next/dynamic";
import { FC, memo, useCallback, useContext, useEffect, useState } from "react";
import ReactGA from 'react-ga';
import { toast } from "react-toastify";
import IMaterialValueForm from "rules/interface/form/material-value.interface";
import LastProjectService from "services/last-project";

const HandleQuestion = dynamic(() => import("components/_handle_question"))



interface IProps {
    label: string
    back: () => void
    forward: () => void
}

const Renovation: FC<IProps> = ({ label, back, forward }) => {

    const { values, setValues } = useContext(MainFormContext)

    const [currentValue, setCurrentValue] = useState<IMaterialValueForm>({
        renovationItems: values.material?.renovationItems,
    })

    const { isLoading, isSuccess, isError, mutate }: any = useUpdateProject()

    const handleNextStep = useCallback(() => {
        try {
            if (!values.withinGoal) {
                ReactGA.event({
                    category: 'Submit',
                    action: 'Click',
                    label: 'form-choose-project-details'
                });
            }

            mutate({
                id: LastProjectService.getId(),
                data: {
                    renovation: currentValue,
                }
            })

        } catch {
            toast.dark("مشکلی بوجود آمده است، لطفا به پشتیبان گزارش دهید")
        }
    }, [currentValue, values])

    useEffect(() => {
        if (isSuccess) {
            setValues(prev => ({ ...prev, material: ({ ...prev?.material ?? {}, ...currentValue }) }))
            forward()
        }
    }, [isSuccess])

    useEffect(() => {
        if (isError) {
            toast.dark("ارسال اطلاعات با مشکل مواجه شد، لطفا دوباره تلاش کنید")
        }
    }, [isError])


    return (
        <>
            <div className="flex flex-column">
                <h4 className="fw-800 app-text-lg my-md text-gray-700 align-center">{label}</h4>

                <HandleQuestion constant={renovationConstant} setSelected={setCurrentValue} selected={currentValue} />

            </div>

            <div className='flex flex-row gap-15 jcb mt-xl'>
                <Button
                    onClick={() => handleNextStep()}
                    loading={isLoading}
                    className="flex-grow"
                    animation
                    id="form-choose-project-details"
                >
                    مرحله بعد
                </Button>

                <button
                    type="button"
                    onClick={() => back()}
                    className="sidelong__btn fw-700"
                    disabled={isLoading}
                >
                    مرحله قبل
                </button>
            </div>
        </>
    )
}

export default memo(Renovation)